var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Search, Clear } from '@mui/icons-material';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { useSearchStore } from '../store/search';
export var SearchBar = function () {
    var _a = useSearchStore(), search = _a.search, setSearch = _a.setSearch;
    var _b = useState(search), searchText = _b[0], setSearchText = _b[1];
    useEffect(function () {
        var timeout = setTimeout(function () { return setSearch(searchText); }, 250);
        return function () { return clearTimeout(timeout); };
    }, [searchText]);
    return (_jsx(TextField, { sx: { minWidth: '20rem' }, label: "Search", value: searchText, onChange: function (e) { return setSearchText(e.target.value); }, slotProps: {
            input: {
                startAdornment: (_jsx(InputAdornment, __assign({ position: "start" }, { children: _jsx(Search, { color: "primary" }) }))),
                endAdornment: search !== '' && (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(IconButton, __assign({ onClick: function () {
                            setSearch(''); // skip debounce
                            setSearchText('');
                        } }, { children: _jsx(Clear, {}) })) }))),
            },
        } }));
};
